import { Typography } from '@mui/material';
import FlexHeaderContainer from '../../../components/containers/FlexHeaderContainer';

const Header = () => (
  <FlexHeaderContainer>
    <Typography variant="h4" component="h1" color="primary" fontWeight="bold" >
     Readability Tools
    </Typography>
  </FlexHeaderContainer>
);

export default Header;